import { EMarketingSpot } from '@/components/content/EMarketingSpot';
import { useHeaderPanels } from '@/components/content/Header/context/HeaderPanelsContext';
import { emarketingSpotMenuSX } from '@/components/content/Header/styles/eMarketingSpotMenu';
import { Box, ClickAwayListener, Popper, useMediaQuery, useTheme } from '@mui/material';
import { FC } from 'react';

interface EmarketingSpotMenuProps {
	menuDynamicTriggerEspot: string;
	menuDynamicsItemsEspot: string;
	menuDynamicTitleEspot: string;
}

export const EmarketingSpotMenu: FC<EmarketingSpotMenuProps> = ({
	menuDynamicTriggerEspot,
	menuDynamicsItemsEspot,
	menuDynamicTitleEspot,
}) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));
	const { activePanelId, anchorEl, togglePanel, closePanel } = useHeaderPanels();
	const isOpen = activePanelId === menuDynamicTriggerEspot;

	const handleClickAwayListener = (event: MouseEvent | TouchEvent) => {
		const target = event.target as Node;
		if (anchorEl && (anchorEl === target || anchorEl.contains(target))) {
			return;
		}
		closePanel();
	};

	return (
		<Box onClick={(e) => togglePanel(menuDynamicTriggerEspot, e.currentTarget)}>
			<EMarketingSpot
				id={menuDynamicTriggerEspot}
				properties={{ emsName: menuDynamicTriggerEspot }}
			/>
			<Popper
				disablePortal
				anchorEl={anchorEl}
				open={isOpen}
				placement={isMobile ? 'top-start' : 'bottom-start'}
				sx={emarketingSpotMenuSX}
				modifiers={[
					{
						name: 'offset',
						options: {
							offset: [0, 8],
						},
					},
				]}
			>
				<ClickAwayListener onClickAway={handleClickAwayListener}>
					<Box sx={{ backgroundColor: 'white' }}>
						<EMarketingSpot
							id={menuDynamicTitleEspot}
							properties={{ emsName: menuDynamicTitleEspot }}
						/>
						<EMarketingSpot
							id={menuDynamicsItemsEspot}
							properties={{ emsName: menuDynamicsItemsEspot }}
						/>
					</Box>
				</ClickAwayListener>
			</Popper>
		</Box>
	);
};
